/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable dot-notation */
import {error, info} from '../logger/logger';

// Provides the logger which wraps the Pendo API validation ...
export const logPendoValidation = () => {
  const validateInstall = (window['pendo'])?.validateInstall;
  validateInstall?.();
};

// Provides the Pendo initialization success logger ...
export const logInitializeSuccess = () => {
  info(_messages.initialize.success);
};

// Provides the Pendo initialization error logger ...
export const logInitializeError = () => {
  error(_messages.initialize.error);
};

// Provides the Pendo initialization script error logger ...
export const logInitializeInjectError = () => {
  error(_messages.initialize.inject);
};

// Provides the Pendo script injection success logger ...
export const logInjectSuccess = () => {
  info(_messages.inject.success);
};

// Provides the Pendo script injection error logger ...
export const logInjectError = () => {
  error(_messages.inject.error);
};

// Provides the Pendo script dependency error logger ...
export const logInjectDependencyError = () => {
  error(_messages.inject.dependency);
};

// Provides the Pendo script injection api key error logger ...
export const logInjectAPIKeyError = () => {
  error(_messages.inject.apikey);
};

// Provides the Pendo script already injected error logger ...
export const logInjectAvailableError = () => {
  error(_messages.inject.available);
};

// Provides the Pendo script log track success ...
export const logTrackSuccess = () => {
  info(_messages.track.success);
};

// Provides the Pendo script log track error ...
export const logTrackError = () => {
  error(_messages.track.error);
};

// Provides a basic abstraction of Pendo log messages from API implementation.
export const _messages = {
  initialize : {
    success : 'Pendo.initialize has completed successfully. Analytics initialization complete.',
    error   : 'Pendo.initialize has failed, script has been injected but API is not available.',
    inject  : 'Pendo.initialize can not be invoked until after Pendo.injectScript has been called.'
  },
  inject : {
    success    : 'Pendo.injectScript has completed successfully. Analytics pre-initialization complete.',
    error      : 'Pendo.injectScript failed, unable to invoke dependency script function.',
    dependency : 'Pendo.injectScript failed, dependency has not been loaded.',
    apikey     : 'Pendo.injectScript failed, apiKey must be provided.',
    available  : 'Pendo.injectScript has previously been invoked, script is already available.'
  },
  track : {
    success : 'Pendo.track logged successfully.',
    error   : 'Pendo.track logging failed.'
  }
};
